import { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import s from './TasksModal.scss'
import { Tasks } from 'components/common/Tasks'

class TasksModal extends Component {
  render() {
    const {
      showTasksModal,
      toggleTasksModal,
      showScheduleTaskModal,
      title = 'Active Tasks',
      tasks,
      markAsDone,
      markAsNotDone
    } = this.props
    return (
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={showTasksModal}
        toggle={toggleTasksModal}
        size="lg"
      >
        <ModalHeader toggle={toggleTasksModal} className={s.modalHeader}>
          {title}
        </ModalHeader>
        <ModalBody className={s.body}>
          <Tasks
            tasks={tasks}
            markAsNotDone={markAsNotDone}
            markAsDone={markAsDone}
            showScheduleTaskModal={showScheduleTaskModal}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleTasksModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default TasksModal
